import React from "react";
import { Input } from "antd";

const { Search } = Input;

const SearchBar = (props) => {
  return (
    <div>
      <Search
        placeholder={props.placeholder}
        onChange={(value) => props.handleSearch(value)}
        size={props.size}
        style={{ width: 300 }}
      />
    </div>
  );
};

export default SearchBar;
